import { Country, EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { ComplyAdvantageStatus } from '@40seas/entities/comply-advantage';
import { ComplyAdvantageKybResult, SearchBusinessResult, SearchProvider } from '@40seas/entities/search';
import { AddressSchema, BaseEntity, IdentificationSchema, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { BusinessConfirmation } from './business.confirmation.enum';
import { DetailsMatch } from './details.match.enum';

export const SearchBusinessQuerySchema = z.object({
    legalName: z.string(),
    country: EnumSchema(Country).optional(),
    state: z.string().optional(),
    provider: EnumSchema(SearchProvider).optional(),
});

export const SearchBusinessResultSchema = z.object({
    legalName: z.string().optional(),
    address: AddressSchema.optional(),
    dba: z.array(z.string()).optional(),
    phone: z.string().optional(),
    duns: z.string().optional(),
    businessStartDate: z.string().optional(),
    identification: z.array(IdentificationSchema).optional(),
    score: z.number().optional(),
});

export const ComplyAdvantageKybResultSchema = z.object({
    legalName: z.string().optional(),
    address: z.string().optional(),
    businessStartDate: ZodDate.optional(),
    status: z.union([EnumSchema(ComplyAdvantageStatus).optional(), z.array(EnumSchema(ComplyAdvantageStatus).optional())]),
});

export const BusinessVerificationSchema = WithBaseEntitySchema(
    z.object({
        business: z.string(),
        businessConfirmation: EnumSchema(BusinessConfirmation).optional(),
        ownershipMatch: EnumSchema(DetailsMatch).optional(),
        searchMatch: SearchBusinessResultSchema.nullable().optional(),
        complyAdvantageKyb: ComplyAdvantageKybResultSchema.nullable().optional(),
    }),
).strict();

export class BusinessVerification extends FromSchema(BusinessVerificationSchema) implements BaseEntity {
    id: string;
    business: string;
    businessConfirmation?: BusinessConfirmation;
    searchMatch?: SearchBusinessResult;
    complyAdvantageKyb?: ComplyAdvantageKybResult;
    ownershipMatch?: DetailsMatch;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
    seller?: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: Executor;
}
